import {
    LOGIN_EXITO,
    ALMACENAR_PROFESION,
    ALMACENAR_RESIDENCIA,
    CERRAR_SESION,
    SETEAR_ID_PACIENTE_EXITO,
    SOLICITO_INFORMACION_PERFIL_PROFESIONAL_EXITO,
    SOLICITO_TOKEN_PERFIL_PROFESIONAL_EXITO,
    SOLICITO_SUSCRIPCION_PROFESIONAL_EXITO,
    CARGAR_DATOS_PACIENTE_NO_REGISTRADO_EXITO,
    SOLICITO_CANTIDAD_SUSCRIPCION_EXITO,
    ESTADO_PACIENTE_INITIAL,
    SUSPENDO_SUSCRIPTOR_EXITO,
    ACTIVO_SUSCRIPTOR_EXITO,
    CREAR_SUSCRIPTOR_EXITO,
    ACTUALIZAR_PERFIL,
    CARGAR_CONFIGURACION_CALENDARIO,
    CARGAR_CONFIGURACION_CALENDARIO_EXITO,
    ACTUALIZAR_CONFIGURACION_CALENDARIO,
    ACTUALIZAR_CONFIGURACION_CALENDARIO_EXITO,
    CARGAR_CONSULTORIOS_PROFESIONAL,
    CARGAR_CONSULTORIOS_PROFESIONAL_EXITO,
    CREAR_CONSULTORIO_PROFESIONAL_EXITO,
    EDITAR_CONSULTORIO_PROFESIONAL_EXITO,
    BORRAR_CONSULTORIO_PROFESIONAL_EXITO,
    SOLICITO_LOGO_DOCUMENTOS,
    SOLICITO_LOGO_DOCUMENTOS_EXITO,
    SOLICITO_LOGO_DOCUMENTOS_ERROR,
    ACTUALIZAR_LOGO_DOCUMENTOS_EXITO
} from '../types';

// Valida y normaliza la configuración visual del calendario antes de guardarla en Redux.
// Importante: NO inventamos default 14:00–20:00 acá.
// Si no hay configuración válida, guardamos null.
const normalizeCalendarViewSettings = (settings) => {
    if (!settings || !Array.isArray(settings.visibleTimeRanges)) {
        return null;
    }

    const visibleTimeRanges = settings.visibleTimeRanges
        .filter((range) => {
            return (
                range &&
                typeof range.start === 'string' &&
                typeof range.end === 'string' &&
                range.start <= range.end
            );
        })
        .slice(0, 2);

    if (visibleTimeRanges.length === 0) {
        return null;
    }

    return {
        visibleTimeRanges,
        autoScrollToCurrentTime: settings.autoScrollToCurrentTime !== false
    };
};

// Busca la configuración del calendario dentro de la respuesta del login.
// Hoy el backend no la manda en login, pero dejamos esto preparado para más adelante.
const getConfiguracionCalendarioFromLogin = (payload) => {
    return (
        payload?.info_header?.configuracion_calendario ||
        payload?.info_header?.configuracionCalendario ||
        payload?.payloadToken?.configuracion_calendario ||
        payload?.payloadToken?.configuracionCalendario ||
        payload?.configuracion_calendario ||
        payload?.configuracionCalendario ||
        null
    );
};

const toBoolean = (value) => {
    return value === true || value === 1 || value === '1';
};

const normalizarConsultorio = (consultorio) => {
    if (!consultorio) {
        return null;
    }

    return {
        ...consultorio,
        es_default: toBoolean(consultorio.es_default),
        activo: consultorio.activo === undefined ? true : toBoolean(consultorio.activo),
        orden: Number(consultorio.orden || 0)
    };
};

const ordenarConsultorios = (consultorios) => {
    return [...consultorios].sort((a, b) => {

        // El consultorio default siempre queda primero.
        if (a.es_default && !b.es_default) {
            return -1;
        }

        if (!a.es_default && b.es_default) {
            return 1;
        }

        // Después respetamos el orden manual si existe.
        const ordenDiff = Number(a.orden || 0) - Number(b.orden || 0);

        if (ordenDiff !== 0) {
            return ordenDiff;
        }

        // Finalmente ordenamos alfabéticamente.
        return String(a.nombre || '').localeCompare(String(b.nombre || ''));
    });
};

const upsertConsultorio = (consultoriosActuales, consultorioNuevo) => {
    const consultorioNormalizado = normalizarConsultorio(consultorioNuevo);

    if (!consultorioNormalizado) {
        return consultoriosActuales;
    }

    const consultoriosSinNuevo = consultoriosActuales
        .filter((consultorio) => (
            String(consultorio.id) !== String(consultorioNormalizado.id)
        ))
        .map((consultorio) => {
            if (!consultorioNormalizado.es_default) {
                return consultorio;
            }

            return {
                ...consultorio,
                es_default: false
            };
        });

    return ordenarConsultorios([
        ...consultoriosSinNuevo,
        consultorioNormalizado
    ]);
};

const initialState = {
    id_usuario: '',
    nombre: '',
    apellido: '',
    rol: '',
    email: '',
    cantidad_suscripcion: '',
    id_paciente: '',
    nombrePaciente: '',
    apellidoPaciente: '',
    pais: '',
    provincia: '',
    departamento: '',
    localidad: '',
    perfil: {},
    suscripcion: [],
    modifico_email: '',
    nombreTutor: '',
    profesion: '',
    otroProfesional: '',
    ayuda_lectura: '',
    ayuda_letra: '',

    // Configuración visual del calendario.
    // Arranca en null para no pisar la configuración real del backend.
    configuracion_calendario: null,
    configuracion_calendario_cargada: false,
    configuracion_calendario_cargando: false,
    consultorios_profesional: [],
    consultorios_profesional_cargando: false,
    consultorios_profesional_cargados: false,

    logo_documentos_configurado: null,
    logo_documentos_cargando: false,
    logo_documentos_cargado: false,
};

export default function usuariosReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_EXITO: {
            const configuracionCalendarioLogin =
                getConfiguracionCalendarioFromLogin(action.payload);

            const configuracionNormalizada =
                normalizeCalendarViewSettings(configuracionCalendarioLogin);

            return {
                ...state,
                id_usuario: action.payload.payloadToken.id_usuario,
                nombre: action.payload.payloadToken.nombre,
                apellido: action.payload.payloadToken.apellido,
                id_paciente: action.payload.payloadToken.id_paciente,
                nombrePaciente: action.payload.payloadToken.nombrePaciente ? action.payload.payloadToken.nombrePaciente : '',
                rol: action.payload.payloadToken.rol,
                email: action.payload.payloadToken.email,
                ayuda_lectura: action.payload.info_header?.ayuda_lectura,
                ayuda_letra: action.payload.info_header?.ayuda_letra,

                // Hoy el login no trae configuración.
                // Entonces esto queda null + cargada false y Calendario hace el GET.
                configuracion_calendario: configuracionNormalizada,
                configuracion_calendario_cargada: Boolean(configuracionNormalizada),
                configuracion_calendario_cargando: false,

                logo_documentos_configurado: null,
                logo_documentos_cargando: false,
                logo_documentos_cargado: false,
            };
        }

        case ALMACENAR_PROFESION:
            return {
                ...state,
                profesion: action.payload.profession,
                otroProfesional: action.payload.otroProfesional
            };

        case ALMACENAR_RESIDENCIA:
            return {
                ...state,
                pais: action.payload[0],
                provincia: action.payload[1],
                departamento: action.payload[2],
                localidad: action.payload[3]
            };

        case CERRAR_SESION:
            return {
                id_usuario: '',
                nombre: '',
                apellido: '',
                rol: '',
                email: '',
                cantidad_suscripcion: '',
                id_paciente: '',
                nombrePaciente: '',
                apellidoPaciente: '',
                pais: '',
                provincia: '',
                departamento: '',
                localidad: '',
                perfil: {},
                suscripcion: [],
                modifico_email: '',
                nombreTutor: '',
                profesion: '',
                otroProfesional: '',
                ayuda_lectura: '',
                ayuda_letra: '',

                // Al cerrar sesión limpiamos la configuración.
                // No dejamos una configuración vieja en Redux.
                configuracion_calendario: null,
                configuracion_calendario_cargada: false,
                configuracion_calendario_cargando: false,
                consultorios_profesional: [],
                consultorios_profesional_cargando: false,
                consultorios_profesional_cargados: false
            };

        case SETEAR_ID_PACIENTE_EXITO:
            return {
                ...state,
                id_paciente: action.payload.id,
                nombrePaciente: action.payload.nombre,
                apellidoPaciente: action.payload.apellido
            };

        case SOLICITO_INFORMACION_PERFIL_PROFESIONAL_EXITO:
        case CARGAR_DATOS_PACIENTE_NO_REGISTRADO_EXITO:
            return {
                ...state,
                perfil: action.payload
            };

        case ACTUALIZAR_PERFIL:
            return {
                ...state,

                // Actualizo solamente los campos modificados del perfil.
                perfil: {
                    ...state.perfil,
                    ...action.payload
                },

                // También actualizo los datos generales del usuario
                // porque HeaderUno/HeaderDos pueden estar leyendo estos campos.
                nombre: action.payload.nombre ?? state.nombre,
                apellido: action.payload.apellido ?? state.apellido,
                email: action.payload.email ?? state.email
            };

        case SOLICITO_TOKEN_PERFIL_PROFESIONAL_EXITO:
            return {
                ...state,
                modifico_email: action.payload
            };

        case SOLICITO_SUSCRIPCION_PROFESIONAL_EXITO:
        case SUSPENDO_SUSCRIPTOR_EXITO:
        case ACTIVO_SUSCRIPTOR_EXITO:
        case CREAR_SUSCRIPTOR_EXITO:
            return {
                ...state,
                suscripcion: action.payload
            };

        case SOLICITO_CANTIDAD_SUSCRIPCION_EXITO:
            return {
                ...state,
                cantidad_suscripcion: action.payload
            };

        case ESTADO_PACIENTE_INITIAL:
            return {
                ...state,
                id_paciente: '',
                nombrePaciente: '',
                apellidoPaciente: ''
            };

        case CARGAR_CONFIGURACION_CALENDARIO:
            return {
                ...state,
                configuracion_calendario_cargando: true
            };

        case ACTUALIZAR_CONFIGURACION_CALENDARIO:
            return {
                ...state,
                configuracion_calendario_cargando: true
            };

        case CARGAR_CONFIGURACION_CALENDARIO_EXITO:
        case ACTUALIZAR_CONFIGURACION_CALENDARIO_EXITO: {
            const configuracionNormalizada =
                normalizeCalendarViewSettings(action.payload);

            return {
                ...state,

                // Guardamos solamente una configuración válida.
                // Si viniera algo inválido, queda null y Calendario muestra carga/error.
                configuracion_calendario: configuracionNormalizada,
                configuracion_calendario_cargada: Boolean(configuracionNormalizada),
                configuracion_calendario_cargando: false
            };
        }

        case CARGAR_CONSULTORIOS_PROFESIONAL:
            return {
                ...state,
                consultorios_profesional_cargando: true
            };

        case CARGAR_CONSULTORIOS_PROFESIONAL_EXITO:
            return {
                ...state,
                consultorios_profesional: ordenarConsultorios(
                    Array.isArray(action.payload)
                        ? action.payload
                            .map(normalizarConsultorio)
                            .filter(Boolean)
                        : []
                ),
                consultorios_profesional_cargando: false,
                consultorios_profesional_cargados: true
            };

        case CREAR_CONSULTORIO_PROFESIONAL_EXITO:
        case EDITAR_CONSULTORIO_PROFESIONAL_EXITO:
            return {
                ...state,
                consultorios_profesional: upsertConsultorio(
                    state.consultorios_profesional,
                    action.payload
                ),
                consultorios_profesional_cargando: false,
                consultorios_profesional_cargados: true
            };

        case BORRAR_CONSULTORIO_PROFESIONAL_EXITO:
            return {
                ...state,
                consultorios_profesional: state.consultorios_profesional.filter(
                    (consultorio) => String(consultorio.id) !== String(action.payload)
                ),
                consultorios_profesional_cargando: false,
                consultorios_profesional_cargados: true
            };

        /*
        ====================================
        LOGO PARA DOCUMENTOS
        ====================================
        */

        case SOLICITO_LOGO_DOCUMENTOS:
            return {
                ...state,

                logo_documentos_cargando: true,
                logo_documentos_cargado: false
            };


        case SOLICITO_LOGO_DOCUMENTOS_EXITO:
            return {
                ...state,

                logo_documentos_configurado:
                    Boolean(action.payload),

                logo_documentos_cargando: false,
                logo_documentos_cargado: true
            };


        case SOLICITO_LOGO_DOCUMENTOS_ERROR:
            return {
                ...state,

                logo_documentos_cargando: false,
                logo_documentos_cargado: false
            };


        case ACTUALIZAR_LOGO_DOCUMENTOS_EXITO:
            return {
                ...state,

                logo_documentos_configurado:
                    Boolean(action.payload),

                logo_documentos_cargando: false,
                logo_documentos_cargado: true
            };

        default:
            return state;
    }
}